<div class="p-grid">
    <div class="p-col-12">
        <div class="p-grid">
            <div class="p-col-11" style="height: 250px; overflow-y: scroll; overflow-x: scroll;">
                <div [ngStyle]="style">
                    <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-balham"
                        [enableSorting]="enableSorting" [enableFilter]="enableFilter" [rowData]="rowData"
                        [frameworkComponents]="frameworkComponents" [animateRows]="animateRows"
                        [rowSelection]='rowSelection' [columnDefs]="columnDefs" [defaultColDef]="defaultColDef"
                        [getRowStyle]="rowStyle" [singleClickEdit]="singleClickEdit"
                        [suppressClickEdit]="suppressCellSelection" [valueCache]="true"
                        (gridReady)="onGridReady($event)" (keydown)="onCellKeyDown($event)"
                        (rowClicked)="seleccion($event)" [overlayNoRowsTemplate]="'Ninguna fila para mostrar'"
                        [enableColResize]="true" [localeText]="localeText" 
                        ></ag-grid-angular>
                </div>
            </div>
            <div class="p-col-1" style="text-align: left">
                <div class="p-grid">
                    <div class="p-col-6">
                        <table >
                            <div>
                                <div>
                                    <tr>
                                        <td>
                                            <button *ngIf="!botonNuevo" class="littlebuttons" [disabled]="botonNuevo"
                                                style="background-image: url(../../../assets/images/iconos/nuevotable.webp); margin-top: -10px; margin-bottom: -10px"
                                                (click)="enviarSenalGrid('nuevo')" title="Nuevo"></button>
                                            <button *ngIf="botonNuevo" class="littlebuttons" [disabled]="botonNuevo"
                                                style="background-image: url(../../../assets/images/iconos/nuevo-d.webp); margin-top: -10px; margin-bottom: -10px"></button>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style="margin-top: -7px; margin-bottom: -7px">
                                            <button *ngIf="!botonBorrar" class="littlebuttons" [disabled]="botonBorrar"
                                                style="background-image: url(../../../assets/images/iconos/006-eraser.webp); margin-top: -10px; margin-bottom: -10px"
                                                (click)="enviarSenalGrid('eliminar')" title="Eliminar"></button>
                                            <button *ngIf="botonBorrar" class="littlebuttons" [disabled]="botonBorrar"
                                                style="background-image: url(../../../assets/images/iconos/006-eraser-d.webp); margin-top: -10px; margin-bottom: -10px"></button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="margin-top: -7px; margin-bottom: -7px">
                                            <button *ngIf="!botonRegresar" class="littlebuttons"
                                                [disabled]="botonRegresar"
                                                style="background-image: url(../../../assets/images/iconos/regresar.webp); margin-top: -10px; margin-bottom: -10px"
                                                (click)="enviarSenalGrid('cancelar')" title="Cancelar"></button>
                                            <button *ngIf="botonRegresar" class="littlebuttons"
                                                [disabled]="botonRegresar"
                                                style="background-image: url(../../../assets/images/iconos/regresar-d.webp); margin-top: -10px; margin-bottom: -10px"></button>
                                        </td>
                                    </tr>
                                </div>
                            </div>
                        </table>
                    </div>
                    <div class="p-col-6">
                        <tr *ngIf="comboOpciones !== undefined">
                            <td>
                                <div class="p-grid" [ngStyle]="{'pointer-events': tipodetalleactivo}">
                                    <div class="p-col-12" *ngFor="let opcion of comboOpciones"
                                        style="margin-top: -12px">
                                        <label for="TIPODETALLE"></label>
                                        <input id="TIPODETALLE" type="radio" [name]='tipodetalle' [value]="opcion.value"
                                            [(ngModel)]="tipodetalle" (click)="seleccionrdb($event)">{{opcion.label}}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<p-dialog header="Búsqueda de Datos" [(visible)]="displayDialogBusquedaFast" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" [style]="{width: '70vw', height: '70vh'} " (onShow)="onshowbusqF()">
	<app-busquedadlg [arrayOptions]="types" [arregloConsulta]="arregloCons" [tabla]="tabla" [where]="where"
		[busquedaParams]="busquedacampos" (opcionSeleccionada)="manejarSeleccion($event)" [consulta]="consulta"
		[heightguia]="heightguia" [heightguiascrol]="heightguiascrol">
	</app-busquedadlg>
</p-dialog>